import React, { createContext } from "react";

import type { ServerDataSuccess } from "./route";

export interface ProductProviderProps {
  /**
   * Children to wrap with context.
   */
  children: React.ReactNode;
  /**
   * Data provided by server.
   */
  serverData: ServerDataSuccess;
}

export const ProductContext = createContext<Omit<
  ProductProviderProps,
  "children"
> | null>(null);

export function ProductProvider({ children, ...props }: ProductProviderProps) {
  return (
    <ProductContext.Provider value={props}>{children}</ProductContext.Provider>
  );
}
